import { StyleSheet, View, Text, TouchableOpacity } from "react-native";

export function ButtonCP({ text, style, onPress }) {
  return (
    <TouchableOpacity onPress={onPress}>
      <View style={[styles.button, style]}>
        <View>
          <Text style={styles.buttonText}>{text}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    minWidth: 200,
    backgroundColor: "#01786E",
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 16,
    elevation: 8,
  },
  buttonText: {
    color: "#FFF",
    alignSelf: "center",
  },
});
